export default __webpack_public_path__ + "static/media/urbanEye-banner.61f8eaf1.png";